<template>
  <div class="page">

    <main class="main">
      <div class="main-inner">
        <aside class="sidebar">
          <div class="sidebar-title">个人中心</div>
          <el-menu
            :default-active="activeIndex"
            @select="handleSelect"
            @open="handleOpen"
            @close="handleClose"
            background-color="transparent"
            text-color="#333333"
            active-text-color="#ED9D26"
            unique-opened
          >
              <div v-for="item,i in filteredMenuItems" :key="item.key">
                  <el-menu-item v-if="!item.children" :index="`${i+1}`">
                    <span slot="title">{{item.label}}</span>
                  </el-menu-item>
                  <el-submenu v-if="item.children" :index="`${i+1}`">
                    <template slot="title">
                      <span>{{item.label}}</span>
                    </template>
                    <div  v-for="item2,j in item.children" :key="item2.key">
                       <el-menu-item  :index="`${i+1}-${j+1}`" v-if="!item2.children">
                        {{item2.label}}
                      </el-menu-item>
                      <el-submenu :index="`${i+1}-${j+1}`" v-if="item2.children">
                        <template slot="title">{{item2.label}}</template>
                        <el-menu-item-group>
                          <el-menu-item v-for="item3,k in item2.children" :key="item3.key" :index="`${i+1}-${j+1}-${k+1}`">{{item3.label}}</el-menu-item>
                        </el-menu-item-group>
                      </el-submenu>
                    </div>
                  </el-submenu>
              </div>
          </el-menu>
        </aside>

        <section class="content">
          <router-view></router-view>
        </section>
      </div>
    </main>
  </div>
</template>

<script>
import {clearUserInfo} from '@/utils/auth';
import {logout, getInfo}from '@/api/api.js'
export default {
  data() {
    return {
      activeIndex:'1',
      activeKey: 'home',
      userType: '',
      menuItems: [
        { 
          key: 'home', 
          label: '首页', 
          route: '',
          
        },
        { 
          key: 'center',
          label: '用户中心', 
          route: '',
          children:[
            {
              key: 'log', 
              label: '日志信息', 
              route: '',
            },
            {
              key: 'info', 
              label: '修改用户信息', 
              route: '',
            },
            {
              key: 'phone', 
              label: '修改手机号码', 
              route: '',
            },
            {
              key: 'email', 
              label: '修改邮箱', 
              route: '',
            },
            {
              key: 'employer', 
              label: '修改工作单位', 
              route: '',
            },
            {
              key: 'password', 
              label: '修改密码', 
              route: '',
            }
          ]
        },
        { 
          key: 'member', 
          label: '会员管理系统', 
          route: '/personal-center',
          children:[
            {
              key: 'membership', 
              label: '入会申请', 
              route: '',
            },
            {
              key: 'withdrawal', 
              label: '退会申请', 
              route: '',
            },
          ]
        },
        { 
          key: 'course', 
          label: '培训系统', 
          route: '/personal-center',
          children:[
            {
              key: 'registration', 
              label: '培训报名', 
              route: '',
            },
            {
              key: 'cart', 
              label: '课程表', 
              route: '',
            },
            {
              key: 'order', 
              label: '课程订单', 
              route: '',
            },
            {
              key: 'my', 
              label: '我的课程', 
              route: '',
            },
            {
              key: 'progress', 
              label: '学习进度', 
              route: '',
              children:[
                {
                  key: 'offline', 
                  label: '面授学习进度', 
                  route: '',
                },
                {
                  key: 'online', 
                  label: '网络学习进度', 
                  route: '',
                },
              ]
            },
            {
              key: 'clockIn', 
              label: '签到打卡', 
              route: '',
            },
             {
              key: 'grade', 
              label: '成绩查询', 
              route: '',
            },
          ]
        },
        { key: 'logout', label: '退出', route: '/login' }
      ],
      routeMapData:{
        '1': '/personalCenter/index',
        '2-1': '/personalCenter/userCenter/log',
        '2-2': '/personalCenter/userCenter/info',
        '2-3': '/personalCenter/userCenter/phone',
        '2-4': '/personalCenter/userCenter/email',
        '2-5': '/personalCenter/userCenter/info?mode=employer',
        '2-6': '/personalCenter/userCenter/password',
        '3-1': '/personalCenter/memberManagement/membership',
        '3-2': '/personalCenter/memberManagement/withdrawal',
        '4-1': '/personalCenter/trainingSystem/registration',
        '4-2': '/personalCenter/trainingSystem/cart',
        '4-3': '/personalCenter/trainingSystem/order',
        '4-4': '/personalCenter/trainingSystem/my',
        '4-5-1': '/personalCenter/trainingSystem/progress/offline',
        '4-5-2': '/personalCenter/trainingSystem/progress/online',
        '4-6': '/personalCenter/trainingSystem/clockIn',
        '4-7': '/personalCenter/trainingSystem/grade'
      },
      currentRouter:''
    }
  },
  computed: {
    isUserCenter() {
      return this.$route.path.startsWith('/user-center')
    },
    filteredMenuItems() {
      if (this.userType === 'H5_largescreen_company') {
        let arr=this.menuItems.map(item => {
          if (item.key === 'center' && item.children) {
            return {
              ...item,
              children: item.children.filter(child => child.key !== 'employer')
            }
          }
          return item
        })
        return arr
      }
      return this.menuItems
    }
  },
  created() {
    this.loadUserInfo()
    
  },
  watch: {
     '$route':function(to){
         this.initActiveIndex(to)
      }
  },
  methods: {
    loadUserInfo() {
      getInfo().then(res => {
        if (res.data.code === 200) {
          this.userType = res.data.data.roles[0] || 'H5_largescreen_personal'
          if (this.userType === 'H5_largescreen_company'){
            this.routeMapData['2-5']='/personalCenter/userCenter/password'
            delete this.routeMapData['2-6']
          }
        }
        this.initActiveIndex(this.$route)
      })
    },
    initActiveIndex(data) {
      let arr=Object.keys(data.query).map(res => res + '=' + data.query[res])
      this.currentRouter = data.path+(arr.length > 0 ? ('?' + arr.join('&')) : '');
      Object.keys(this.routeMapData).forEach(key => {
        if(this.routeMapData[key] === this.currentRouter){
          this.activeIndex = key
        }
      });
    },
    handleSelect(index) { 
      if (index === '5') {
         this.$confirm('确定要退出登录吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            logout().then(res=>{
              if(res.data.code==200){
                clearUserInfo()
                window.dispatchEvent(new Event('loginStatusChanged'))
                this.$message.success('退出登录成功')
                this.$router.replace('/')
              }else{
                this.$message.error('退出登录失败')
              }
            })
          }).catch(() => {
            
          })
        return
      }
      const route = this.routeMapData[index]
      if (route&&route!=this.currentRouter) {
        this.$router.push(route)
      }
    },
    handleOpen(e){
      // console.log(e)
    },
    handleClose(e){
      // console.log(e)
    },
    go(route) {
      this.$router.push(route)
    }
  }
}
</script>

<style lang="less" scoped>
.page {
  min-height: 100vh;
  background: #f2f2f2;
  color: #333;
  padding-top: 20PX;
  .main {
    width:80%;
    margin:0 auto;

    .main-inner {
      display: flex;

      .sidebar {
        width: 237px;
        background: #fff;
        border-radius: 24px;
        padding:32px 20px 24px;
        flex-shrink: 0;
        .sidebar-title {
          margin-bottom: 24px;
          font-size: 24px;
          color: #333333;
          text-align: center;
          font-weight: bold;
        }

        .menu {

          .menu-item {
            padding: 13px 24px;
            font-size: 16px;
            color: #333333;
            border-radius: 12px;
            cursor: pointer;
            margin-top:12px;
            font-weight: bold;
            // &.active {
            //   background: #FFF3E2;
            //   color: #ED9D26;
            // }

          }
        }
        /deep/ .el-submenu.is-active{
          background: #FFF3E2 !important;
          color: #fff !important;
          border-radius: 12px;
        }
        // /deep/ .el-submenu.is-active{
        //   color: rgb(237, 157, 38);
        // }
      }

      .content {
        flex: 1;
        margin-left: 20px;
      }
    }
  }
}
.el-menu{
  border-right: none;
}
::v-deep .el-submenu__title,.el-menu-item{
  font-size: 16px;
  background-color:transparent !important;
  min-width:auto;
}
::v-deep .el-submenu__title i {
  color: #333333;
  font-weight: bold;
}
::v-deep .el-menu-item.is-active{
  background-color: #fff3e2 !important;
  border-radius: 12px;
}

::v-deep .el-submenu .is-active{
  // background-color: #fff3e2 !important;
  // border-radius: 12px;
}
</style>
